export class RestoreGoogleWorkspaceGroupMessagesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "files",
            "baseName": "files",
            "type": "Array<FilePath>",
            "format": ""
        },
        {
            "name": "restoreTargetGroup",
            "baseName": "restoreTargetGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreTargetMailboxes",
            "baseName": "restoreTargetMailboxes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "restoreTargetLabel",
            "baseName": "restoreTargetLabel",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGoogleWorkspaceGroupMessagesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
